import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withKeys as _withKeys, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-100bd023"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-logo" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "/assets/img/logo.svg" })
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Chegou a hora de atualizar sua versão do nosso aplicativo ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = ["href"]
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Atualizar")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Para usufruir de todas as funcionalidades do nosso aplicativo precisamos dos seguintes dados ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("NOME")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("CPF")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Data de Nascimento")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Continuar")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Para usufruir de todas as funcionalidades do nosso aplicativo precisamos do seu CPF para continuar ")
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Informe seu CPF ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("CPF")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Confirmar CPF")
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Estamos quase lá!")
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Preencha o número do seu celular e aproveite todas as novidades do App Jaú Serve! ")
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Celular:")
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_34 = /*#__PURE__*/_createTextVNode("Confirmar")
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Digite o código enviado para seu telefone celular ")
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" Informe o código ")
const _hoisted_42 = { class: "txt-sms" }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_45 = /*#__PURE__*/_createTextVNode("Confirmar")
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" Login com código ")
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-logo" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "/assets/img/logo.svg" })
], -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" Receber código de acesso por e-mail ")
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_56 = /*#__PURE__*/_createTextVNode("Enviar Solicitação")
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" Digite o código enviado para seu e-mail ")
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_60 = /*#__PURE__*/_createTextVNode("Enviar Solicitação")
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" Redefinir Senha ")
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-logo" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "/assets/img/logo.svg" })
], -1))
const _hoisted_63 = /*#__PURE__*/_createTextVNode(" Você receberá um código de recuperação de senha por e-mail ")
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_70 = /*#__PURE__*/_createTextVNode("Enviar")
const _hoisted_71 = /*#__PURE__*/_createTextVNode(" Digite o código enviado para seu e-mail ")
const _hoisted_72 = /*#__PURE__*/_createTextVNode(" Sua senha precisa: ")
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" Conter ao menos um número ")
const _hoisted_74 = /*#__PURE__*/_createTextVNode(" Conter ao menos uma letra maiúscula ")
const _hoisted_75 = /*#__PURE__*/_createTextVNode(" As senhas digitadas não são iguais ")
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_78 = /*#__PURE__*/_createTextVNode("Enviar")
const _hoisted_79 = { class: "ion-padding background" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-logo" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "/assets/img/logo.svg" })
], -1))
const _hoisted_81 = {
  novalidate: "",
  class: "ion-padding"
}
const _hoisted_82 = /*#__PURE__*/_createTextVNode(" Olá, que bom ")
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_84 = /*#__PURE__*/_createTextVNode("ter você aqui! ")
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_88 = /*#__PURE__*/_createTextVNode("CONFIRMAR")
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "assets/icon/google.svg" }, null, -1))
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "assets/icon/facebook.svg" }, null, -1))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "assets/icon/apple.svg" }, null, -1))
const _hoisted_92 = /*#__PURE__*/_createTextVNode(" Entre ou cadastre-se ")
const _hoisted_93 = /*#__PURE__*/_createTextVNode(" Informe seu CPF para continuar ")
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_100 = /*#__PURE__*/_createTextVNode("CONFIRMAR")
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/assets/icon/aviso.svg" }, null, -1))
const _hoisted_102 = /*#__PURE__*/_createTextVNode(" AGORA UNIFICAMOS AS SENHAS DO SITE E DO APP ")
const _hoisted_103 = /*#__PURE__*/_createTextVNode(" Então, se você já é usuário do site Jaú Serve e lembra a sua senha, é só utilizar a mesma aqui no App. ")
const _hoisted_104 = /*#__PURE__*/_createTextVNode(" Caso queira redefinir a sua senha por aqui, só não esqueça que ela também trocará no site. ")
const _hoisted_105 = /*#__PURE__*/_createTextVNode("FECHAR")
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_107 = { "padding-left": "" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_110 = /*#__PURE__*/_createTextVNode("ENVIAR")
const _hoisted_111 = /*#__PURE__*/_createTextVNode(" Esqueceu a senha? ")
const _hoisted_112 = /*#__PURE__*/_createTextVNode("Clique aqui")
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_115 = /*#__PURE__*/_createTextVNode("Entrar com código único")
const _hoisted_116 = /*#__PURE__*/_createTextVNode(" Entrar como visitante ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_SelectDia = _resolveComponent("SelectDia")!
  const _component_v_otp_input = _resolveComponent("v-otp-input")!
  const _component_VueCountdown = _resolveComponent("VueCountdown")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_ion_alert = _resolveComponent("ion-alert")!
  const _component_ion_loading = _resolveComponent("ion-loading")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_page = _resolveComponent("ion-page")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_modal, {
        ref: "modal",
        trigger: "open-update",
        "is-open": _ctx.updateApp
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_content, { class: "ion-padding" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, { class: "ion-align-items-center bg_white" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { size: "1" }),
                  _createVNode(_component_ion_col, { size: "9" }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, { size: "2" })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    class: "ion-text-center font-montserrat font-30",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2,
                      _hoisted_3,
                      _hoisted_4,
                      _hoisted_5,
                      _hoisted_6
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "ion-align-items-center bg_white" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { size: "3" }),
                  _createVNode(_component_ion_col, {
                    size: "6",
                    class: "ion-text-center"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        href: _ctx.updateApp_info.link
                      }, [
                        _createElementVNode("img", {
                          src: 'assets/icon/'+_ctx.updateApp_info.image + '.svg'
                        }, null, 8, _hoisted_8),
                        _hoisted_9,
                        _hoisted_10
                      ], 8, _hoisted_7)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, { size: "3" })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open"]),
      _createVNode(_component_ion_modal, {
        ref: "modal",
        trigger: "open-modal",
        "is-open": _ctx.capturaALL
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.goto();_ctx.capturaALL=false}),
            color: "dark",
            size: "large",
            fill: "clear"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_icon, { icon: _ctx.chevronBack }, null, 8, ["icon"])
            ]),
            _: 1
          }),
          _createVNode(_component_ion_content, { class: "ion-padding" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    class: "font-montserrat font-15",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "font-raleway font-15",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { position: "stacked" }, {
                        default: _withCtx(() => [
                          _hoisted_12
                        ]),
                        _: 1
                      }),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "input-cadastro-cpf",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cadastro.nome) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.cadastro.nome]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "font-raleway font-15",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { position: "stacked" }, {
                        default: _withCtx(() => [
                          _hoisted_13
                        ]),
                        _: 1
                      }),
                      _withDirectives(_createElementVNode("input", {
                        type: "tel",
                        class: "input-cadastro-cpf",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cadastro.cpf) = $event)),
                        onMaska: _cache[3] || (_cache[3] = ($event: any) => (_ctx.cadastro.cpf_v = $event.target.dataset.maskRawValue))
                      }, null, 544), [
                        [_vModelText, _ctx.cadastro.cpf],
                        [_directive_maska, ['###.###.###-##', '##.###.###/####-##']]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "font-raleway font-15",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { position: "stacked" }, {
                        default: _withCtx(() => [
                          _hoisted_14
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, {
                            class: "font-raleway",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_SelectDia, {
                                "onUpdate:modelValue": _ctx.cadastro,
                                data: _ctx.cadastro
                              }, null, 8, ["onUpdate:modelValue", "data"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "ion-text-center",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateNovosDados())),
                        size: "large",
                        shape: "round",
                        color: "jauservelayoutalter"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_15
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open"]),
      _createVNode(_component_ion_modal, {
        ref: "modal",
        trigger: "open-modal",
        "is-open": _ctx.capturaCPF
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_button, {
            onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.goto();_ctx.capturaCPF=false}),
            color: "dark",
            size: "large",
            fill: "clear"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_icon, { icon: _ctx.chevronBack }, null, 8, ["icon"])
            ]),
            _: 1
          }),
          _createVNode(_component_ion_content, { class: "ion-padding" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _hoisted_16,
                  _hoisted_17,
                  _createVNode(_component_ion_col, {
                    class: "font-montserrat font-15",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_18
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "font-montserrat font-30",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_19,
                      _hoisted_20
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "font-raleway font-30",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { position: "stacked" }, {
                        default: _withCtx(() => [
                          _hoisted_21
                        ]),
                        _: 1
                      }),
                      _withDirectives(_createElementVNode("input", {
                        type: "tel",
                        class: "input-cadastro-cpf",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.cadastro.cpf) = $event)),
                        onMaska: _cache[7] || (_cache[7] = ($event: any) => (_ctx.cadastro.cpf_v = $event.target.dataset.maskRawValue))
                      }, null, 544), [
                        [_vModelText, _ctx.cadastro.cpf],
                        [_directive_maska, ['###.###.###-##', '##.###.###/####-##']]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "ion-text-center",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.updateNovosDados())),
                        size: "large",
                        shape: "round",
                        color: "jauservelayout"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_22
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open"]),
      _createVNode(_component_ion_modal, {
        ref: "modal",
        trigger: "open-modal",
        "is-open": _ctx.capturaCELULAR
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_button, {
            onClick: _cache[9] || (_cache[9] = ($event: any) => {_ctx.goto();_ctx.capturaCELULAR=false}),
            color: "dark",
            size: "large",
            fill: "clear"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_icon, { icon: _ctx.chevronBack }, null, 8, ["icon"])
            ]),
            _: 1
          }),
          _createVNode(_component_ion_content, { class: "ion-padding" }, {
            default: _withCtx(() => [
              (!_ctx.cadastro.pin)
                ? (_openBlock(), _createBlock(_component_ion_row, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        class: "font-montserrat font-15",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_23,
                          _hoisted_24,
                          _hoisted_25,
                          _hoisted_26,
                          _hoisted_27,
                          _hoisted_28,
                          _hoisted_29
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "font-montserrat font-30",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { position: "stacked" }, {
                            default: _withCtx(() => [
                              _hoisted_30
                            ]),
                            _: 1
                          }),
                          _withDirectives(_createElementVNode("input", {
                            type: "tel",
                            class: "input-cadastro-mobile",
                            placeholder: "(xx)xxxxx-xxxx",
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.cadastro.celular) = $event)),
                            onMaska: _cache[11] || (_cache[11] = ($event: any) => (_ctx.cadastro.celular_v = $event.target.dataset.maskRawValue))
                          }, null, 544), [
                            [_vModelText, _ctx.cadastro.celular],
                            [_directive_maska, ['(##)# ####-####', '(##)# ####-####']]
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "ion-text-center",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_31,
                          _hoisted_32,
                          _hoisted_33,
                          _createVNode(_component_ion_button, {
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.callValidacao())),
                            size: "large",
                            shape: "round",
                            color: "jauservelayoutalter"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_34
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_ion_row, { key: 1 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        class: "ion-text-center font-montserrat font-15",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_35,
                          _hoisted_36,
                          _hoisted_37
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "ion-text-center font-montserrat font-30",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_38,
                          _hoisted_39,
                          _hoisted_40,
                          _hoisted_41
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "font-montserrat font-15",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_otp_input, {
                            ref: "otpInput",
                            "input-classes": 'input-custom-cadastro',
                            separator: "     ",
                            "num-inputs": 4,
                            "should-auto-focus": false,
                            "is-input-num": true,
                            onOnComplete: _ctx.handleOnComplete,
                            placeholder: ['*', '*', '*', '*']
                          }, null, 8, ["onOnComplete"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "ion-text-center font-montserrat font-12",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, {
                            color: "light",
                            size: "small",
                            shape: "round",
                            disabled: _ctx.cadastro.pin,
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.callValidacao()))
                          }, {
                            default: _withCtx(() => [
                              (_ctx.cadastro.pin)
                                ? (_openBlock(), _createBlock(_component_VueCountdown, {
                                    key: 0,
                                    time: 60000,
                                    onEnd: _cache[13] || (_cache[13] = ($event: any) => (_ctx.cadastro.pin=false))
                                  }, {
                                    default: _withCtx(({ totalSeconds }) => [
                                      _createElementVNode("span", _hoisted_42, "Solicitar novamente em " + _toDisplayString(totalSeconds) + " segundos ", 1)
                                    ]),
                                    _: 1
                                  }))
                                : (_openBlock(), _createElementBlock("span", _hoisted_43, " Solicitar Novo Código"))
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "ion-text-center",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_44,
                          _createVNode(_component_ion_button, {
                            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.updateNovosDados())),
                            size: "large",
                            shape: "round",
                            color: "jauservelayoutalter"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_45
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open"]),
      _createVNode(_component_ion_modal, {
        ref: "modal_codigo",
        onDidDismiss: _cache[21] || (_cache[21] = ($event: any) => (_ctx.capturaCodUnico=false)),
        "is-open": _ctx.capturaCodUnico,
        "initial-breakpoint": 0.85,
        breakpoints: [0, 0.85, 0.85, 0.85]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_button, {
            onClick: _cache[16] || (_cache[16] = ($event: any) => {_ctx.goto();_ctx.capturaCodUnico=false}),
            color: "jauservelayout",
            size: "large",
            fill: "clear"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_icon, { icon: _ctx.close }, null, 8, ["icon"]),
              _hoisted_46
            ]),
            _: 1
          }),
          _createVNode(_component_ion_content, { class: "ion-padding background" }, {
            default: _withCtx(() => [
              _hoisted_47,
              _createVNode(_component_swiper, {
                allowTouchMove: false,
                zoom: false,
                onSwiper: _ctx.onSwiper
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_swiper_slide, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          _hoisted_48,
                          _createVNode(_component_ion_col, {
                            class: "font-montserrat font-15",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_49
                            ]),
                            _: 1
                          }),
                          _hoisted_50,
                          _hoisted_51,
                          _createVNode(_component_ion_col, {
                            class: "font-montserrat font-15",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_input, {
                                modelValue: _ctx.username,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.username) = $event)),
                                onInput: _cache[18] || (_cache[18] = ($event: any) => (_ctx.username=$event.target.value)),
                                name: "username",
                                class: "custom",
                                placeholder: "digite seu email",
                                type: "email",
                                spellcheck: "false",
                                autocapitalize: "off",
                                required: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _hoisted_52,
                          _hoisted_53,
                          _hoisted_54,
                          _hoisted_55,
                          _createVNode(_component_ion_col, {
                            class: "ion-text-center",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.onPinCode())),
                                size: "large",
                                shape: "round",
                                color: "jauservelayout"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_56
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_swiper_slide, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, {
                            class: "ion-text-center font-montserrat font-15",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_57
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, {
                            class: "font-montserrat font-15",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_otp_input, {
                                ref: "otpInput",
                                "input-classes": 'input-cadastro-pincode',
                                separator: "       ",
                                "num-inputs": 6,
                                "should-auto-focus": false,
                                "is-input-num": true,
                                onOnComplete: _ctx.handleOnComplete,
                                placeholder: ['*', '*', '*', '*', '*', '*']
                              }, null, 8, ["onOnComplete"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, {
                            class: "ion-text-center font-montserrat font-12",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_58,
                              _hoisted_59,
                              _createVNode(_component_ion_col, {
                                class: "ion-text-center",
                                size: "12"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_button, {
                                    onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.onPinCode())),
                                    size: "large",
                                    shape: "round",
                                    color: "jauservelayout"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_60
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onSwiper"]),
              _createVNode(_component_ion_row)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open", "initial-breakpoint", "breakpoints"]),
      _createVNode(_component_ion_modal, {
        ref: "modal_codigo",
        onDidDismiss: _cache[33] || (_cache[33] = ($event: any) => (_ctx.capturaNovaSenha=false)),
        "is-open": _ctx.capturaNovaSenha,
        "initial-breakpoint": 0.95,
        breakpoints: [0, 0.95, 0.95, 0.95]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_button, {
            onClick: _cache[22] || (_cache[22] = ($event: any) => {_ctx.goto();_ctx.capturaNovaSenha=false}),
            size: "large",
            color: "jauservelayout",
            fill: "clear"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_icon, { icon: _ctx.close }, null, 8, ["icon"]),
              _hoisted_61
            ]),
            _: 1
          }),
          _createVNode(_component_ion_content, { class: "ion-padding background" }, {
            default: _withCtx(() => [
              _hoisted_62,
              _createVNode(_component_swiper, {
                allowTouchMove: false,
                zoom: false,
                onSwiper: _ctx.onSwiper
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_swiper_slide, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, {
                            class: "font-montserrat font-15",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_63
                            ]),
                            _: 1
                          }),
                          _hoisted_64,
                          _hoisted_65,
                          _createVNode(_component_ion_col, {
                            class: "font-montserrat font-15",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_input, {
                                modelValue: _ctx.username,
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.username) = $event)),
                                onInput: _cache[24] || (_cache[24] = ($event: any) => (_ctx.username=$event.target.value)),
                                name: "username",
                                class: "custom",
                                placeholder: "digite seu email",
                                type: "email",
                                spellcheck: "false",
                                autocapitalize: "off",
                                required: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _hoisted_66,
                          _hoisted_67,
                          _hoisted_68,
                          _hoisted_69,
                          _createVNode(_component_ion_col, {
                            class: "ion-text-center",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.onPinLostCode())),
                                size: "large",
                                shape: "jau",
                                color: "jauservelayoutalter"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_70
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_swiper_slide, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, {
                            class: "ion-text-start font-montserrat font-15",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_71
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, {
                            class: "font-montserrat font-15",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_otp_input, {
                                ref: "otpInput",
                                "input-classes": 'input-custom-cadastro',
                                separator: "     ",
                                "num-inputs": 6,
                                "should-auto-focus": false,
                                "is-input-num": true,
                                onOnComplete: _ctx.handleOnComplete,
                                placeholder: ['*', '*', '*', '*', '*', '*']
                              }, null, 8, ["onOnComplete"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, {
                                class: "font-montserrat font-15",
                                size: "12"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_72
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, {
                                class: "font-montserrat font-11 light-gray",
                                size: "12"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    icon: _ctx.v$.cadastro.password.minLength.$invalid ? _ctx.close :_ctx.checkmark
                                  }, null, 8, ["icon"]),
                                  _createTextVNode(" Ter pelo menos " + _toDisplayString(_ctx.v$.cadastro.password.minLength.$params.min) + " caracteres ", 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, {
                                class: "font-montserrat font-11 light-gray",
                                size: "12"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    icon: _ctx.v$.cadastro.password.hasnumber.$invalid ? _ctx.close :_ctx.checkmark
                                  }, null, 8, ["icon"]),
                                  _hoisted_73
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, {
                                class: "font-montserrat font-11 light-gray",
                                size: "12"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    icon: _ctx.v$.cadastro.password.hasupper.$invalid ? _ctx.close :_ctx.checkmark
                                  }, null, 8, ["icon"]),
                                  _hoisted_74
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, {
                                class: "font-montserrat font-15",
                                size: "10"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_input, {
                                    modelValue: _ctx.cadastro.password,
                                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.cadastro.password) = $event)),
                                    onInput: _cache[27] || (_cache[27] = ($event: any) => (_ctx.cadastro.password=$event.target.value)),
                                    name: "username",
                                    class: "custom",
                                    placeholder: "Nova senha",
                                    type: _ctx.passwordType?'password':'text',
                                    spellcheck: "false",
                                    autocapitalize: "off",
                                    required: ""
                                  }, null, 8, ["modelValue", "type"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, {
                                class: "font-montserrat font-30",
                                size: "2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    icon: _ctx.passwordType?_ctx.eyeOffOutline:_ctx.eyeOutline,
                                    onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.passwordType=!_ctx.passwordType))
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, {
                                class: "font-montserrat font-15",
                                size: "10"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_input, {
                                    modelValue: _ctx.cadastro.password_conf,
                                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.cadastro.password_conf) = $event)),
                                    onInput: _cache[30] || (_cache[30] = ($event: any) => (_ctx.cadastro.password_conf=$event.target.value)),
                                    name: "password",
                                    class: "custom",
                                    placeholder: "Confirmar nova senha",
                                    type: _ctx.passwordType?'password':'text',
                                    spellcheck: "false",
                                    autocapitalize: "off",
                                    required: ""
                                  }, null, 8, ["modelValue", "type"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, {
                                class: "font-montserrat font-30 light-gray",
                                size: "2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    icon: _ctx.passwordTypeConf?_ctx.eyeOffOutline:_ctx.eyeOutline,
                                    onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.passwordTypeConf=!_ctx.passwordTypeConf))
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              }),
                              (_ctx.cadastro.password!=_ctx.cadastro.password_conf)
                                ? (_openBlock(), _createBlock(_component_ion_col, {
                                    key: 0,
                                    class: "font-montserrat font-11 light-gray",
                                    size: "12"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, { icon: _ctx.close }, null, 8, ["icon"]),
                                      _hoisted_75
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, {
                            class: "ion-text-center font-montserrat font-12",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_76,
                              _hoisted_77,
                              _createVNode(_component_ion_col, {
                                class: "ion-text-center",
                                size: "12"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_button, {
                                    onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.onPinLostCode())),
                                    size: "large",
                                    shape: "jau",
                                    color: "jauservelayoutalter"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_78
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onSwiper"]),
              _createVNode(_component_ion_row)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open", "initial-breakpoint", "breakpoints"]),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, { size: "2" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_ion_button, {
                      onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.voltar())),
                      color: "dark",
                      size: "large",
                      fill: "#fff"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          slot: "start",
                          icon: _ctx.chevronBack
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                size: "9",
                class: "font-poppins-extra font-25"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_alert, {
            "is-open": _ctx.isOpenRef,
            header: "Atenção",
            message: "Email ou Senha Inválidos",
            buttons: ['OK'],
            onDidDismiss: _cache[35] || (_cache[35] = ($event: any) => (_ctx.isOpenRef=false))
          }, null, 8, ["is-open"]),
          _createVNode(_component_ion_alert, {
            "is-open": _ctx.isOpenRefCode,
            header: "Atenção",
            message: "Código digitado inválido",
            buttons: ['OK'],
            onDidDismiss: _cache[36] || (_cache[36] = ($event: any) => (_ctx.isOpenRefCode=false))
          }, null, 8, ["is-open"]),
          _createVNode(_component_ion_alert, {
            "is-open": _ctx.isOpenRefCodeEmail,
            header: "Atenção",
            message: "Email digitado não localizado<br>Faça seu <b>cadastro</b> agora mesmo!",
            buttons: ['OK'],
            onDidDismiss: _cache[37] || (_cache[37] = ($event: any) => {_ctx.gotoCadastro();_ctx.isOpenRefCodeEmail=false})
          }, null, 8, ["is-open"]),
          _createVNode(_component_ion_loading, { "is-open": _ctx.isOpenLoading }, null, 8, ["is-open"]),
          _createElementVNode("div", _hoisted_79, [
            _hoisted_80,
            _createElementVNode("form", _hoisted_81, [
              _createVNode(_component_ion_row, { "responsive-sm": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_swiper, {
                    onSwiper: _ctx.setControlledSwiper,
                    allowTouchMove: false,
                    zoom: false,
                    slidesPerView: 1,
                    spaceBetween: 0,
                    centeredSlides: true
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_swiper_slide, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, {
                                class: "ion-text-center text-bemvindo",
                                size: "12"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_82,
                                  _hoisted_83,
                                  _hoisted_84,
                                  _hoisted_85
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_row, { "responsive-sm": "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, null, {
                                default: _withCtx(() => [
                                  _hoisted_86,
                                  _hoisted_87,
                                  _createVNode(_component_ion_button, {
                                    onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.goNext())),
                                    color: "jauservelayoutalter",
                                    size: "large",
                                    shape: "jau",
                                    expand: "block"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_88
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_row, { "responsive-sm": "" }, {
                            default: _withCtx(() => [
                              (_ctx.login_cfg.google)
                                ? (_openBlock(), _createBlock(_component_ion_col, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_button, {
                                        onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.onLoginGoogle())),
                                        fill: "#fff",
                                        size: "large",
                                        expand: "block"
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_89
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.login_cfg.facebook)
                                ? (_openBlock(), _createBlock(_component_ion_col, { key: 1 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_button, {
                                        onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.onLoginFacebook())),
                                        fill: "#fff",
                                        size: "large",
                                        expand: "block"
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_90
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.login_cfg.apple)
                                ? (_openBlock(), _createBlock(_component_ion_col, { key: 2 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_button, {
                                        onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.onLoginApple())),
                                        fill: "#fff",
                                        size: "large",
                                        expand: "block"
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_91
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_swiper_slide, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, {
                                class: "ion-text-start font-montserrat-bold font-20",
                                size: "12"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_92
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, {
                                class: "ion-text-start font-montserrat",
                                size: "12"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_93,
                                  _hoisted_94
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _hoisted_95,
                          _hoisted_96,
                          _withDirectives(_createElementVNode("input", {
                            enterkeyhint: "search",
                            type: "tel",
                            class: "input-cadastro-cpf-layout",
                            "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.cadastro.cpf) = $event)),
                            placeholder: "CPF Cadastrado",
                            onKeydown: _cache[43] || (_cache[43] = _withKeys(_withModifiers(($event: any) => (_ctx.goCPF()), ["prevent"]), ["tab"])),
                            onKeyup: _cache[44] || (_cache[44] = _withKeys(($event: any) => (_ctx.goCPF()), ["enter"])),
                            onMaska: _cache[45] || (_cache[45] = ($event: any) => (_ctx.cadastro.cpf_v = $event.target.dataset.maskRawValue))
                          }, null, 544), [
                            [_vModelText, _ctx.cadastro.cpf],
                            [_directive_maska, ['###.###.###-##', '##.###.###/####-##']]
                          ]),
                          _createVNode(_component_ion_row, { "responsive-sm": "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, null, {
                                default: _withCtx(() => [
                                  _hoisted_97,
                                  _createTextVNode(_toDisplayString(_ctx.CPF_error), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_row, { "responsive-sm": "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, null, {
                                default: _withCtx(() => [
                                  _hoisted_98,
                                  _hoisted_99
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_row, { "responsive-sm": "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_button, {
                                    onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.goCPF())),
                                    color: "jauservelayoutciza6",
                                    size: "large",
                                    shape: "jau",
                                    expand: "block"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_100
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_swiper_slide, null, {
                        default: _withCtx(() => [
                          (_ctx.show_unificar)
                            ? (_openBlock(), _createBlock(_component_ion_row, {
                                key: 0,
                                class: "modal-senha-uni"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_col, {
                                    class: "ion-text-center",
                                    size: "12"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_101
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_col, {
                                    class: "ion-text-center font-25",
                                    size: "12"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_102
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_col, {
                                    class: "ion-text-center",
                                    size: "12"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_103
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_col, {
                                    class: "ion-text-center",
                                    size: "12"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_104
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_col, {
                                    class: "ion-text-center",
                                    size: "12"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_button, {
                                        onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.show_unificar=false)),
                                        fill: "outline",
                                        color: "light",
                                        size: "large"
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_105
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_ion_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, {
                                class: "ion-text-center text-bemvindo",
                                size: "12"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_106
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_input, {
                            modelValue: _ctx.username,
                            "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.username) = $event)),
                            onInput: _cache[49] || (_cache[49] = ($event: any) => (_ctx.username=$event.target.value)),
                            name: "username",
                            type: "email",
                            class: "item_pesquisa_layout",
                            inputmode: "email",
                            spellcheck: "false",
                            placeholder: "E-MAIL",
                            autocapitalize: "off",
                            required: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    color: "jauservelayout",
                                    size: "medium",
                                    slot: "end",
                                    icon: _ctx.at
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_ion_text, { color: "danger" }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("p", _hoisted_107, null, 512), [
                                [_vShow, !_ctx.usernameValid || _ctx.submitted == true]
                              ])
                            ]),
                            _: 1
                          }),
                          _hoisted_108,
                          _createVNode(_component_ion_input, {
                            modelValue: _ctx.passwords,
                            "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.passwords) = $event)),
                            onInput: _cache[51] || (_cache[51] = ($event: any) => (_ctx.passwords=$event.target.value)),
                            class: "item_pesquisa_layout",
                            placeholder: "Senha",
                            name: "password",
                            type: "password",
                            onKeydown: _cache[52] || (_cache[52] = _withKeys(_withModifiers(($event: any) => (_ctx.onLogin(_ctx.username, _ctx.passwords)), ["prevent"]), ["tab"])),
                            onKeyup: _cache[53] || (_cache[53] = _withKeys(($event: any) => (_ctx.onLogin(_ctx.username, _ctx.passwords)), ["enter"])),
                            enterkeyhint: "done",
                            required: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    color: "jauservelayout",
                                    size: "medium",
                                    slot: "end",
                                    icon: _ctx.lockClosed
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _hoisted_109,
                          _createVNode(_component_ion_row, { "responsive-sm": "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_button, {
                                    onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.onLogin(_ctx.username, _ctx.passwords))),
                                    color: "jauservelayoutalter",
                                    size: "large",
                                    shape: "jau",
                                    expand: "block"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_110
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_row, { class: "ion-align-items-center ion-no-padding" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, {
                                class: "ion-text-end font-montserrat font-12 ion-no-padding",
                                size: "5"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_111
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, { size: "7" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_button, {
                                    onClick: _cache[55] || (_cache[55] = ($event: any) => (_ctx.capturaNovaSenha=true)),
                                    size: "small",
                                    color: "danger",
                                    fill: "clear"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_112
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onSwiper"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { "responsive-sm": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _hoisted_113,
                      _hoisted_114
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { "responsive-sm": "" }, {
                default: _withCtx(() => [
                  (_ctx.login_cfg.mail)
                    ? (_openBlock(), _createBlock(_component_ion_col, {
                        key: 0,
                        class: "ion-text-center",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, {
                            onClick: _cache[56] || (_cache[56] = ($event: any) => (_ctx.capturaCodUnico=true)),
                            color: "jauservelayoutalter",
                            fill: "outline",
                            size: "large",
                            shape: "jau",
                            expand: "block"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                slot: "start",
                                icon: _ctx.mail
                              }, null, 8, ["icon"]),
                              _hoisted_115
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_ion_col, {
                    class: "ion-text-center",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[57] || (_cache[57] = ($event: any) => (_ctx.goGuest())),
                        color: "dark",
                        fill: "outline",
                        shape: "jau",
                        size: "large",
                        expand: "block"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_116
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}